<template>
    <div class="common-footer">
        <small>
            Copyright © {{ new Date().getFullYear() }} Seller's Shield. All rights reserved.
        </small>

        <ul class="common-footer-nav">
            <li
                class="common-footer-nav-item"
            >
                <a
                    id="help-summoner"
                    @click="expandChat"
                    role="helpsummoner">
                    Help
                </a>
            </li>
            <slot></slot>
        </ul>
    </div>
</template>

<script>
import './CommonFooter.scss';
import {mapState} from 'pinia';
import {useAuthStore} from '@store';
import {isAgent} from '@helpers/user';

export default {
    name: 'CommonFooter',
    data: () => ({}),
    computed: {
        ...mapState(useAuthStore, {
            me: 'me',
        }),
    },
    methods: {
        expandChat() {
            if (window.SellersShieldZohoDesk) {
                window.SellersShieldZohoDesk.expandChat();
            }
        },
        async identifyHeapUser() {
            const heap = window.heap;

            if (heap && this.me && window.APP_ENV !== 'local') {
                let userProperties = {
                    emailAddress: this.me.email,
                    firstName: this.me.firstName,
                    lastName: this.me.lastName,
                    accountType: this.me.accountType?.slug,
                };

                if (isAgent(this.me)) {
                    userProperties.licenseState = this.me.state?.title;
                }

                heap.identify(userProperties.emailAddress);
                heap.addUserProperties(userProperties);
            }
        },
    },
    async created() {
        await this.identifyHeapUser();
    }
}
</script>
